import i18n from "i18next"

export function t(key : string, params? : any) {
    return i18n.t(key, params);
}
export async function setupI18n()  {
    try {
        await i18n.init({
            lng: 'en',
            debug: true,
            resources: {
                en: {
                    translation: {
                        forms : {
                            submit : "Create Account",
                            email : {
                                label : "E-mail",
                                help : "",
                                invalid : "Please enter a valid e-mail"
                            },
                            password : {
                                label : "Password",
                                help : "",
                                length: "Password has to be at least 8 characters long and contain a lowercase, uppercase letter as well as a number"
                            },
                            repeatPassword : {
                                label : "Repeat password",
                                help : ""
                            },
                            screenname : {
                                label : "Screen name",
                                help : "Displayed to other players when playing poker",
                                unavailable : "The screen name you provided is already in taken",
                                invalid : "Invalid screen name"

                            },
                            selectScreenName : "Select Screen Name",
                            acceptTerms : "By clicking 'Create Account' you  agree that you have read and accepted our Terms of service."

                        },
                        search : {
                            placeholder : "Search Games"
                        },
                        casino: {
                            category: {
                                TableGames : "Table Games",
                                New: "New",
                                Popular: "Popular",
                                LiveDealer: "Live Dealer",
                                VideoSlots: "Slots",
                                Arcade : "Arcade Games"
                            }
                        }
                    }
                }
            }
        });
    } catch (e) {
        console.error("Unable to initialize i18n", e)
    }
}